import { ExperimentPage } from '~/cf-worker/types';

export const experimentedPages: ExperimentPage[] = [
  {
    experimentKey: 'school_lp_redesign',
    name: 'School Landing Page Redesign Feature Flag',
    // Note: as of 5/1/2025, we will only run the new school landing page on non-legacy school lps.
    // Once we have the content ready for the legacy school lps, we can update this regex to include all school lps.
    pathRegex:
      /^\/school\/(?!data-science|business|programming|artificial-intelligence|cybersecurity|product-management|executive-leadership|autonomous-systems|career-resources$).+$/,
    type: 'flag',
  },
  {
    experimentKey: 'flubber',
    name: "Master's dashboard access",
    pathRegex: /^\/masters-degree\/[^/]+$/,
    type: 'flag',
    options: { requiresAuth: true },
  },
  {
    experimentKey: 'ab_checkout_revamp',
    name: 'Checkout revamp AB test',
    pathRegex: /^\/(quick-checkout|checkout)(\/|$)/,
    type: 'experiment',
  },
  {
    experimentKey: 'memorial-day-sale-2026',
    name: 'Memorial Day Sale 2026',
    pathRegex: /^(\/|\/experience|\/catalog)$/,
    type: 'flag',
  },
  {
    experimentKey: 'agentic-ai-ft-2026',
    name: 'Agentic AI Free Trial 2026',
    pathRegex: /^(\/course\/agentic-ai--nd900|\/catalog|\/experience|\/)$/,
    type: 'flag',
  },
];
